export const DEFAULT_PARAMETER_WEIGHT = 1
export const MAX_PARAMETER_WEIGHT = 10
